import { Device } from 'DeviceUtils';
import { ViewStyle } from 'react-native';
import Theme from 'Theme';

const gridView: ViewStyle = {
    paddingTop: 11,
    paddingBottom: Device.isWeb ? 0 : Theme.BU * 2,
    flex: 1,
};
const footerIndicator: ViewStyle = {
    flex: 1,
    marginTop: -20,
    marginBottom: 20
};

export default { gridView, footerIndicator };
